// extracted by mini-css-extract-plugin
export default {"description":"LongTextColumn_description__Z8lWx","nowrap":"LongTextColumn_nowrap__+bVTM","normal":"LongTextColumn_normal__Xf9In"};